import {
  getByIdProfileSelector,
  getValueReduxUtil,
  PROFILE_KEY
} from '@gymaholic/packages'

export default function getAvatarNameByIdProfileSelector (id) {
  return state => {
    const profile = getByIdProfileSelector(id)(state)
    const name = getValueReduxUtil(profile, PROFILE_KEY.NAME) || ''
    const firstLetter = (
      name[0] || ''
    ).toUpperCase()

    const secondLetter = (
      name[1] || ''
    ).toUpperCase()
    return `${firstLetter}${secondLetter}`
  }
}
